var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D7C3E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40227 19.7758C15.7336 16.5506 25.2209 12.6183 26.5305 12.0741C29.9658 10.6496 31.0199 10.9226 30.4943 14.0772C30.1169 16.3446 29.0278 23.8516 28.1598 28.5241C27.6447 31.2949 26.4891 31.6233 24.672 30.4246C23.7982 29.8476 19.3876 26.931 18.4304 26.2461C17.5565 25.622 16.3514 24.8712 17.8628 23.3925C18.4006 22.8657 21.9263 19.4993 24.6732 16.879C25.0331 16.5348 24.581 15.9696 24.1657 16.2455C20.4633 18.7007 15.3299 22.1086 14.6766 22.5525C13.6896 23.2227 12.7417 23.5301 11.0401 23.0413C9.75444 22.6721 8.49852 22.2316 8.00969 22.0636C6.12727 21.4173 6.5741 20.5802 8.40227 19.7758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.2c897a525fcf7f37b28d932758b62233.svg";
export { ForwardRef as ReactComponent };